import { render, staticRenderFns } from "./UseApp.vue?vue&type=template&id=6d21f654"
import script from "./UseApp.vue?vue&type=script&lang=js"
export * from "./UseApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports